import { render, staticRenderFns } from "./SelfHelpTools.vue?vue&type=template&id=497e1324"
import script from "./SelfHelpTools.vue?vue&type=script&lang=js"
export * from "./SelfHelpTools.vue?vue&type=script&lang=js"
import style0 from "./SelfHelpTools.vue?vue&type=style&index=0&id=497e1324&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports